import { api, unwrap } from "./httpClient";
import type { ChatMessage, ChatReadResponse, ChatRoom, UserSummary } from "../types/api";

export const listRooms = () =>
  unwrap<ChatRoom[]>(api({ method: "GET", url: "/chats" }));

export const ensureRoom = (participantId?: number) =>
  unwrap<ChatRoom>(
    api({ method: "POST", url: "/chats", data: participantId ? { participantId } : {} })
  );

export const listMessages = (roomId: number) =>
  unwrap<ChatMessage[]>(
    api({ method: "GET", url: `/chats/${roomId}/messages` })
  );

export const sendMessage = (roomId: number, content: string) =>
  unwrap<ChatMessage>(
    api({ method: "POST", url: `/chats/${roomId}/messages`, data: { content } })
  );

/** Envoi d’une image (JPEG, PNG, WebP, GIF), avec légende optionnelle. */
export const sendChatImage = (
  roomId: number,
  file: File,
  caption?: string
) => {
  const fd = new FormData();
  fd.append("file", file);
  if (caption?.trim()) {
    fd.append("content", caption.trim());
  }
  return unwrap<ChatMessage>(
    api({
      method: "POST",
      url: `/chats/${roomId}/messages/image`,
      data: fd,
      timeout: 120_000,
    })
  );
};

export const markRoomRead = (roomId: number) =>
  unwrap<ChatReadResponse>(api({ method: "POST", url: `/chats/${roomId}/read` }));

export const listContacts = () =>
  unwrap<UserSummary[]>(api({ method: "GET", url: "/chats/contacts" }));

